
<template>
  <v-container>
    <v-row v-if="false">
      <v-col cols="12" class="text-right">
        <v-btn class="ma-2" color="indigo white--text" dark>
          {{ $t("tableLogger.download") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="blue darken-4 white--text">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <h3>{{ $t("tableLogger.title") }}</h3>
                </v-col>
                <v-col cols="6" md="2" offset-md="2">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="start_time"
                        append-icon="today"
                        background-color="white"
                        placeholder="Start Time"
                        outlined
                        readonly
                        hide-details
                        dense
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="start_time"
                      @input="findLogs(), (menu1 = false)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" md="2">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="end_time"
                        append-icon="today"
                        background-color="white"
                        placeholder="Start Time"
                        outlined
                        readonly
                        hide-details
                        dense
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="end_time"
                      @input="findLogs(), (menu2 = false)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" offset-md="3">
                  <v-autocomplete
                    :items="model_types"
                    :label="$t('tableLogger.model')"
                    dense
                    solo
                    hide-details
                    @change="findLogs"
                    v-model="model_type"
                    clearable
                  />
                </v-col>
                <v-col cols="6" md="3">
                  <v-autocomplete
                    :items="organizations"
                    :label="$t('tableLogger.organization')"
                    dense
                    solo
                    item-value="id"
                    item-text="name"
                    hide-details
                    @change="findLogs"
                    v-model="organization_id"
                    clearable
                  />
                </v-col>
                <v-col cols="6" md="3">
                  <v-autocomplete
                    :items="users"
                    :label="$t('tableLogger.user')"
                    @change="findLogs"
                    v-model="user_id"
                    dense
                    item-text="email"
                    item-value="id"
                    solo
                    flat
                    outlined
                    hide-details
                    clearable
                  />
                  </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="logsTable.headers"
              :items="logs"
              :loading.sync="logsTable.loading"
              :page.sync="logsTable.pagination.page"
              :server-items-length="logsTable.pagination.itemsLength"
              :items-per-page.sync="logsTable.pagination.itemsPerPage"
              :sort-by.sync="logsTable.pagination.sortBy"
              :sort-desc.sync="logsTable.pagination.sortDesc"
              :footer-props="{
                'items-per-page-options': [25, 50, 100],
              }"
              :multi-sort="false"
              :must-sort="false"
              @click:row="findDetails"
              @update:items-per-page="findLogs"
              @update:sort-by="findLogs"
              @update:sort-desc="findLogs"
              flat
            >
              <template v-slot:[`item.request`]="{ item }">
                {{ item.description }}
              </template>
              <template v-slot:loading>
                <v-skeleton-loader
                  v-bind="attrs"
                  type="table-row, table-row, table-row, table-row, table-row"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-navigation-drawer
        v-model="drawer"
        :permanent="drawer"
        fixed
        temporary
        right
        width="40%"
      >
        <BaseToolbar
          :title="$t('tableLogger.detail')"
          type-title="icon"
          icon="business"
          :button-save="false"
          @close="closeDrawer"
        />
        <v-container v-if="log">
          <v-row>
            <v-col cols="12">
              <v-expansion-panels v-model="panels" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-2">{{
                    $t("tableLogger.datab")
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" class="py-1">
                        <div class="subtitle-2">
                          <span class="font-weight-black"
                            >{{ $t("tableLogger.description") }}:</span
                          >
                          {{ log.description }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="py-1">
                        <div class="subtitle-2">
                          <span class="font-weight-black"
                            >{{ $t("tableLogger.model") }}:</span
                          >
                          {{ log.model_type }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="py-1">
                        <div class="subtitle-2">
                          <span class="font-weight-black"
                            >{{ $t("tableLogger.organization") }}:</span
                          >
                          {{ log.organization.name }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="py-1">
                        <div class="subtitle-2">
                          <span class="font-weight-black"
                            >{{ $t("tableLogger.email") }}:</span
                          >
                          {{ log.user.email }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-2">{{
                    $t("tableLogger.model")
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        cols="12"
                        class="py-1"
                        style="max-height: 400px; overflow: auto"
                      >
                        <VueJsonPretty :data="log.model" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-2">{{
                    $t("tableLogger.request")
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        cols="12"
                        class="py-1"
                        style="max-height: 400px; overflow: auto"
                      >
                        <VueJsonPretty :data="log.request" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header class="subtitle-2">{{
                    $t("tableLogger.response")
                  }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col
                        cols="12"
                        class="py-1"
                        style="max-height: 400px; overflow: auto"
                      >
                        <VueJsonPretty :data="log.response" />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-container>
      </v-navigation-drawer>
    </v-row>
  </v-container>
</template>

<script>
import BaseToolbar from '@/components/BaseToolbar'
import PgtUtilMix from '@/mixins/PgtUtilMix'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  components: { BaseToolbar, VueJsonPretty },
  mixins: [PgtUtilMix],
  data: ref => ({
    panels: [0],
    drawer: false,
    model_types: [
      'guests',
      'subscriptions',
      'invoices',
      'invitations',
      'forms_defaults',
      'gateway_organizations',
      'exportations',
      'hook_events_organizations',
      'forms',
      'leads',
      'events',
      'tags',
      'filters',
      'custom_fields',
      'groups',
      'tickets',
      'emails',
      'claro_petitions',
      'organization_term_and_conditions',
      'gateway_organizations',
      'donations',
      'projects',
      'docs',
      'donations',
      'campaigns',
      'forms',
      'organization_modules',
      'registrations',
      'account_activities',
      'imports',
      'images',
      'certifications',
      'claro_audits',
      'donation_certificate_batches',
      'annual_certificates',
      'organization_domains',
      'email_accounts',
      'email_triggers',
      'templates',
      'template_translations',
      'organization_facebook_pages',
      'organization_addons',
      'organization_addon_availables',
      'organization_integrations',
      'files',
      'categories',
      'user_organizations'
    ],
    menu1: false,
    menu2: false,
    start_time: ref.$moment
      ? ref
        .$moment()
        .subtract(1, 'week')
        .format('YYYY-MM-DD')
      : '',
    end_time: ref.$moment ? ref.$moment().format('YYYY-MM-DD') : '',
    model_type: '',
    search: '',
    organization_id: null,
    logsTable: {
      loading: true,
      search: '',
      items: [],
      headers: [
        {
          sortable: false,
          text: ref.$t('tableLogger.user'),
          value: 'user.email',
          align: 'left',
          class: 'blue--text text--darken-4'
        },
        {
          sortable: false,
          text: ref.$t('tableLogger.organization'),
          value: 'organization.name',
          align: 'left',
          class: 'blue--text text--darken-4'
        },
        {
          sortable: true,
          text: ref.$t('tableLogger.model'),
          value: 'model_type',
          align: 'left',
          class: 'blue--text text--darken-4'
        },
        {
          text: ref.$t('tableLogger.description'),
          value: 'description',
          align: 'left',
          class: 'blue--text text--darken-4'
        },
        {
          text: ref.$t('tableLogger.date'),
          value: 'created_at',
          align: 'left',
          class: 'blue--text text--darken-4',
          sortable: true
        },
        {
          text: ref.$t('tableLogger.status'),
          value: 'status',
          align: 'left',
          class: 'blue--text text--darken-4',
          sortable: false
        }
      ],
      pagination: {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 25,
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 25, text: 25 },
          { value: 100, text: 100 }
        ],
        sortBy: ['created_at'],
        sortDesc: [true]
      }
    },
    attrs: {
      class: 'align-left',
      boilerplate: true,
      elevation: 0
    },
    loading: false,
    user_id: null
  }),
  mounted () {
    /** Use debounce to not collapse backend petitions */
    this.findLogs = this.pgtDebounce(this.findLogs, 1000)
    this.findLogs()
    this.getOrganizations()
    this.getUsers()
  },
  computed: {
    ...mapState({
      users: ({ logger: { users } }) => users,
      organizations: ({ logger: { organizations } }) => organizations,
      logs: ({ logger: { logs } }) => logs,
      log: ({ logger: { log } }) => log
    })
  },
  methods: {
    ...mapActions({
      getOrganizations: 'logger/getOrganizations',
      getLogs: 'logger/getLogs',
      getLog: 'logger/getDetails',
      getUsers: 'logger/getUsers'
    }),
    ...mapMutations({
      setLog: 'logger/SETLOG'
    }),
    async findLogs () {
      // eslint-disable-next-line camelcase
      const { model_type, organization_id, user_id } = this
      // eslint-disable-next-line camelcase
      const { start_time, end_time } = this
      const { page, itemsPerPage } = this.logsTable.pagination
      let { sortBy, sortDesc } = this.logsTable.pagination
      if (sortBy && sortBy.length > 0) {
        [sortBy] = sortBy
      }
      if (sortDesc && sortBy.length > 0) {
        [sortDesc] = sortDesc
        if (sortDesc === false) {
          sortDesc = 'asc'
        } else if (sortDesc) {
          sortDesc = 'desc'
        }
      }
      const { search } = this.logsTable
      this.logsTable.loading = true // Effect Loading Table
      try {
        const result = (
          await this.getLogs({
            params: {
              user_id,
              organization_id,
              model_type,
              search,
              start_time,
              end_time,
              page,
              rowsPerPage: itemsPerPage,
              sortBy,
              sortDirection: sortDesc
            }
          })
        )

        const { page: pageResponse, total, data } = result
        this.logsTable.pagination.page = pageResponse // Update actual page (optional)
        // this.logsTable.items = data
        this.logsTable.pagination.itemsLength = Number(total)
      } catch (error) {
        // La busqueda dio un error
        console.log(error)
      }

      this.logsTable.loading = false
    },
    async findDetails (item) {
      const { id } = item
      try {
        await this.getLog(id)
        this.drawer = true
      } catch (error) {
        console.log(error)
      }
    },
    closeDrawer () {
      this.drawer = false
      this.setLog(null)
    }
  },
  watch: {
    'logsTable.pagination.page': function () {
      this.findLogs()
    }
  }
}
</script>
